import { useNavigate } from "react-router-dom";

const ActTable = ({ data }) => {
    const navigate = useNavigate();
    const handleClick = (href) => {
        const encodedUrl = encodeURIComponent(href)
        navigate(`/portal/actNotes/${encodedUrl}`)

    }
    return (
        <table className="border-collapse w-full text-center">
            <tbody>
                {data.slice(1).map((row, rowIndex) => {
                    const actualIndex = rowIndex + 1;
                    const isTitleRow = actualIndex === 1;
                    const isHeadingRow =
                        !isTitleRow &&
                        (row.length === 1 || row.every(cell => cell.href === null));

                    return (
                        <tr key={rowIndex}>
                            {row.length === 1 ? (
                                <td
                                    colSpan={2}
                                    className={`border border-white/20 px-4 py-3 align-middle ${isTitleRow
                                        ? "font-bold text-xl bg-white/10"
                                        : isHeadingRow
                                            ? "font-semibold text-lg bg-white/5"
                                            : ""
                                        }`}
                                >
                                    {row[0].href ? (
                                        <a
                                            href={row[0].href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-400 cursor-pointer hover:underline "

                                        >
                                            {row[0].text}
                                        </a>
                                    ) : (
                                        row[0].text
                                    )}
                                </td>
                            ) : (
                                row.map((cell, cellIndex) => (
                                    <td
                                        key={cellIndex}
                                        className={`border border-white/20 px-4 py-3 align-middle ${isTitleRow
                                            ? "font-bold text-xl bg-white/10"
                                            : isHeadingRow
                                                ? "font-semibold text-lg bg-white/5"
                                                : ""
                                            }`}
                                    >
                                        {cell.href ? (
                                            <a

                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-blue-400 cursor-pointer hover:underline"
                                                onClick={() => { handleClick(cell.href) }}
                                            >
                                                {cell.text}
                                            </a>
                                        ) : (
                                            cell.text
                                        )}
                                    </td>
                                ))
                            )}
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
};

export default ActTable;
